// Temps total ajusté au nombre de personnes.
// Seule la préparation augmente ; la cuisson (four/mijotage) reste constante.
// Intensité modérée : +50% de préparation quand on double le nombre de personnes.
export function adjustedTotalTime(recipe, servings) {
  const prep = recipe.prep_time_minutes || 0;
  const cook = recipe.cook_time_minutes || 0;
  const base = recipe.servings || 2;
  const target = servings || base;
  const ratio = base > 0 ? target / base : 1;
  const factor = Math.max(0.5, 1 + 0.5 * (ratio - 1));
  return Math.round(prep * factor) + cook;
}
